/**
 * The platform's help-assistant mark (#3624): two stacked roof lines, from
 * `docs/brand/beyond/svg/beyond-symbol.svg`.
 *
 * Inline SVG so it follows the theme: the upper roof is always the accent
 * colour; the lower roof is navy in light mode and white in dark mode. It is
 * the platform's own brand mark (like the assistant's name, which still comes
 * from the status payload), so it is the one sanctioned exception to the
 * Lucide-only icon rule, and it carries no agency branding. Decorative: the
 * heading next to it names the assistant, so it is hidden from assistive tech.
 */
interface BeyondMarkProps {
  /** Rendered width in px; the height follows the 40:36 artwork. Default 20. */
  size?: number;
  className?: string;
}

export function BeyondMark({ size = 20, className = "" }: BeyondMarkProps) {
  return (
    <svg
      viewBox="12 12 40 36"
      width={size}
      height={Math.round((size * 36) / 40)}
      aria-hidden="true"
      focusable="false"
      data-testid="beyond-mark"
      className={`shrink-0 ${className}`}
    >
      <g
        fill="none"
        strokeWidth={6}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline
          points="16,42 32,28 48,42"
          stroke="currentColor"
          className="text-[var(--color-navy)] dark:text-[#ffffff]"
        />
        <polyline points="20,28 32,17.5 44,28" stroke="var(--color-accent)" />
      </g>
    </svg>
  );
}
